import { getCurrencyRequestRpc, getPublicCurrencyResponseRpc } from 'growth-monetization-service-types';
import { rpcClient, noAuthRpcClient } from '../../rpcClient';
export const fetchCurrency = ({
  isPublicUseCase
}) => {
  const fallbackCurrencyCode = 'USD';
  const currencyPromise = isPublicUseCase ? noAuthRpcClient.call(getPublicCurrencyResponseRpc, {
    pathParameters: {
      browserLocale: getBrowserLocale()
    },
    queryParameters: {
      preferredCountryCode: getPreferredCountryCode()
    }
  }) : rpcClient.call(getCurrencyRequestRpc, {});
  return currencyPromise.then(currencyResponse => {
    return currencyResponse.defaultCurrencyCode;
  }, error => {
    console.error('Failed to fetch currency', error);
    return fallbackCurrencyCode;
  });
};
function getBrowserLocale() {
  const navigator = window.navigator;
  const preferredLanguage = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '';
  return preferredLanguage || 'en-us';
}
function getPreferredCountryCode() {
  const isInIndia = window.location.host.indexOf('hubspot.in') > -1;

  // the (window as any).COUNTRY_CODE_FROM_LOCALE should be set BEFORE the early requester script is loaded in the base jade file
  return isInIndia ? 'IN' : window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
}